import styled from 'styled-components';


const ContainerCards = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    @media (max-width: 350px) {
         width: 80%;
    }
`;

export default ContainerCards;
